export const CATEGORIES = [
  "Analgésicos",
  "Antibióticos",
  "Antihipertensivos",
  "Antidiabéticos",
  "Antialérgicos",
  "Antigripales",
  "Gastrointestinales",
  "Vitaminas",
  "Cardiovasculares",
  "Salud Mental",
  "Antiparasitarios",
  "Otro",
];

export const ZONES = [
  "Centro",
  "Norte",
  "Sur",
  "Oriente",
  "Poniente",
  "Zona Metropolitana",
  "Otra",
];

export const POPULAR_MEDICINES = [
  { name: "Paracetamol 500 mg",   category: "Analgésicos" },
  { name: "Ibuprofeno 400 mg",    category: "Analgésicos" },
  { name: "Amoxicilina 500 mg",   category: "Antibióticos" },
  { name: "Azitromicina 500 mg",  category: "Antibióticos" },
  { name: "Metformina 850 mg",    category: "Antidiabéticos" },
  { name: "Insulina NPH (vial)",  category: "Antidiabéticos" },
  { name: "Losartán 50 mg",       category: "Antihipertensivos" },
  { name: "Enalapril 10 mg",      category: "Antihipertensivos" },
  { name: "Omeprazol 20 mg",      category: "Gastrointestinales" },
  { name: "Loratadina 10 mg",     category: "Antialérgicos" },
  { name: "Complejo B",           category: "Vitaminas" },
  { name: "Atorvastatina 20 mg",  category: "Cardiovasculares" },
];

export const UNIT_LABELS = [
  "tabletas",
  "cápsulas",
  "sobres",
  "ampolletas",
  "ml",
  "gotas",
  "piezas",
];
